module.exports = "pegasus/assets/theme6/small/2.jpg";